import { ContentFrame } from "@/components/layout/content-frame";
import { ToastZone } from "@/components/layout/toast-zone";
import { TopNav } from "@/components/layout/top-nav";
import { Outlet, createRootRoute } from "@tanstack/react-router";

export const Route = createRootRoute({
  component: () => (
    <ToastZone>
      <TopNav />
      <ContentFrame>
        <Outlet />
      </ContentFrame>
    </ToastZone>
  ),
});
